import firebase from "firebase/app";
import "firebase/firestore";
import firebaseConfig from "./firebaseKeys";



firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore();
